import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Form,
  FormGroup,
  FormText,
  Input,
  Label,
  Spinner,
} from 'reactstrap';
import styled from 'styled-components';
import {
  saveTiposBoletinAction,
  setActivoTiposBoletinAction,
} from '../../../../store/actions';

const FormWrapper = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Section = styled.section`
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1rem;
  background: #fafbfc;
`;

const SectionTitle = styled.h6`
  margin: 0 0 0.75rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6c757d;
`;

const CompactLabel = styled(Label)`
  font-size: 0.78rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
  color: #495057;
`;

const FormFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
  padding-top: 0.25rem;
  border-top: 1px solid #e9ecef;
`;

const FormTiposBoletin = ({ onClose }) => {
  const dispatch = useDispatch();
  const tiposBoletinState = useSelector((state) => state.tiposBoletin);

  const isEditing = Boolean(tiposBoletinState.activo);

  const [nombre, setNombre] = useState('');
  const [isActivo, setIsActivo] = useState('true');
  const [loadingSave, setLoadingSave] = useState(false);

  useEffect(() => {
    if (tiposBoletinState.activo) {
      setNombre(tiposBoletinState.activo.nombre ?? '');
      setIsActivo(tiposBoletinState.activo.isActivo ? 'true' : 'false');
    } else {
      setNombre('');
      setIsActivo('true');
    }
  }, [tiposBoletinState.activo]);

  const handleClose = () => {
    setActivoTiposBoletinAction(dispatch, null);
    onClose?.();
  };

  const handlerSubmit = async () => {
    if (!nombre.trim()) return;

    setLoadingSave(true);
    const ok = await saveTiposBoletinAction(
      dispatch,
      tiposBoletinState.activo?.id,
      {
        nombre: nombre.trim(),
        isActivo: isActivo === 'true',
      }
    );
    setLoadingSave(false);

    if (ok) {
      setActivoTiposBoletinAction(dispatch, null);
      onClose?.();
    }
  };

  return (
    <FormWrapper onSubmit={(e) => e.preventDefault()}>
      <Section>
        <SectionTitle>
          {isEditing ? 'Editar tipo de boletín' : 'Nuevo tipo de boletín'}
        </SectionTitle>

        <FormGroup className="mb-3">
          <CompactLabel for="nombre">Nombre *</CompactLabel>
          <Input
            id="nombre"
            bsSize="sm"
            name="nombre"
            value={nombre}
            required
            placeholder="Ej: Diciembre 2024, La Liebre..."
            autoFocus
            onChange={(e) => setNombre(e.target.value)}
          />
          <FormText className="mb-0">
            Nombre visible en el selector público del newsletter.
          </FormText>
        </FormGroup>

        <FormGroup className="mb-0">
          <CompactLabel for="isActivo">Estado</CompactLabel>
          <Input
            id="isActivo"
            bsSize="sm"
            name="isActivo"
            type="select"
            value={isActivo}
            onChange={(e) => setIsActivo(e.target.value)}
          >
            <option value="true">Activo</option>
            <option value="false">Bloqueado</option>
          </Input>
          <FormText className="mb-0">
            Solo los tipos activos se muestran en la web pública.
          </FormText>
        </FormGroup>
      </Section>

      <FormFooter>
        <Button
          color="light"
          size="sm"
          type="button"
          disabled={loadingSave}
          onClick={handleClose}
        >
          Cancelar
        </Button>
        <Button
          color={isEditing ? 'primary' : 'success'}
          size="sm"
          type="button"
          disabled={loadingSave || !nombre.trim()}
          onClick={handlerSubmit}
        >
          {loadingSave ? (
            <>
              <Spinner size="sm" />
              &nbsp;Guardando…
            </>
          ) : isEditing ? (
            'Actualizar'
          ) : (
            'Guardar'
          )}
        </Button>
      </FormFooter>
    </FormWrapper>
  );
};

export default FormTiposBoletin;
